export default __webpack_public_path__ + "static/media/train2.ee6fb55e.jpg";